export default "__VITE_ASSET__CEpq$Txu__"